<div #vantaBg class="vanta-background">
  <div class="lightning-overlay"></div>

  <!-- Ambient floating particles -->
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>
  <div class="ambient-particle"></div>

  <!-- Background Lightning Visuals - CANVA LIGHTNING BOLTS -->
  <div class="visual-container active" id="purpleLightning" style="z-index: 5">
    <svg
      class="lightning-illustration"
      viewbox="0 0 1920 1080"
      xmlns="http://www.w3.org/2000/svg"
      preserveaspectratio="xMidYMid slice"
    >
      <defs>
        <lineargradient id="blueThunder" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color: #1e3a8a; stop-opacity: 1" />
          <stop offset="50%" style="stop-color: #3b82f6; stop-opacity: 1" />
          <stop offset="100%" style="stop-color: #93c5fd; stop-opacity: 1" />
        </lineargradient>
        <filter id="glow">
          <fegaussianblur stddeviation="5" result="coloredBlur" />
          <femerge>
            <femergenode in="coloredBlur" />
            <femergenode in="SourceGraphic" />
          </femerge>
        </filter>
      </defs>

      <!-- Main lightning bolt 1 -->
      <g class="thunder-bolt-1">
        <path
          d="M960 50 L955 100 L965 105 L950 160 L970 170 L945 240 L960 245 L935 310 L955 320 L925 400 L945 410 L915 490 L935 500 L900 610 L920 620 L890 710 L910 720 L880 810 L900 820 L870 910 L890 920 L860 1010"
          stroke="url(#blueThunder)"
          stroke-width="5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          filter="url(#glow)"
        />
        <path
          d="M960 50 L955 100 L965 105 L950 160 L970 170 L945 240 L960 245 L935 310 L955 320 L925 400 L945 410 L915 490 L935 500 L900 610 L920 620 L890 710 L910 720 L880 810 L900 820 L870 910 L890 920 L860 1010"
          stroke="#bfdbfe"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.8"
        />
        <!-- Branch off -->
        <path
          d="M945 240 L980 280 L970 320"
          stroke="url(#blueThunder)"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.7"
        />
        <path
          d="M925 400 L890 440 L900 480"
          stroke="url(#blueThunder)"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.7"
        />
        <path
          d="M890 710 L860 750 L870 790"
          stroke="url(#blueThunder)"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.7"
        />
      </g>

      <!-- Side lightning bolt 2 -->
      <g class="thunder-bolt-2">
        <path
          d="M400 100 L395 150 L405 155 L390 210 L410 220 L385 290 L400 295 L375 370 L395 380 L365 460 L385 470 L355 550 L375 560 L345 640 L365 650 L335 730 L355 740 L325 820 L345 830 L315 910"
          stroke="url(#blueThunder)"
          stroke-width="4"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          filter="url(#glow)"
        />
        <path
          d="M400 100 L395 150 L405 155 L390 210 L410 220 L385 290 L400 295 L375 370 L395 380 L365 460 L385 470 L355 550 L375 560 L345 640 L365 650 L335 730 L355 740 L325 820 L345 830 L315 910"
          stroke="#bfdbfe"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.7"
        />
        <!-- Branch -->
        <path
          d="M385 290 L420 330 L410 370"
          stroke="url(#blueThunder)"
          stroke-width="2.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.6"
        />
        <path
          d="M355 550 L390 590 L380 630"
          stroke="url(#blueThunder)"
          stroke-width="2.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.6"
        />
      </g>

      <!-- Side lightning bolt 3 -->
      <g class="thunder-bolt-3">
        <path
          d="M1520 150 L1515 200 L1525 205 L1510 260 L1530 270 L1505 340 L1520 345 L1495 420 L1515 430 L1485 510 L1505 520 L1475 600 L1495 610 L1465 690 L1485 700 L1455 780 L1475 790 L1445 870 L1465 880 L1435 960"
          stroke="url(#blueThunder)"
          stroke-width="4"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          filter="url(#glow)"
        />
        <path
          d="M1520 150 L1515 200 L1525 205 L1510 260 L1530 270 L1505 340 L1520 345 L1495 420 L1515 430 L1485 510 L1505 520 L1475 600 L1495 610 L1465 690 L1485 700 L1455 780 L1475 790 L1445 870 L1465 880 L1435 960"
          stroke="#bfdbfe"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.7"
        />
        <!-- Branch -->
        <path
          d="M1505 340 L1470 380 L1480 420"
          stroke="url(#blueThunder)"
          stroke-width="2.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.6"
        />
        <path
          d="M1475 600 L1510 640 L1500 680"
          stroke="url(#blueThunder)"
          stroke-width="2.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.6"
        />
      </g>

      <!-- Behind-form lightning bolts -->
      <g class="thunder-bolt-behind-1">
        <path
          d="M850 80 L845 130 L855 135 L840 190 L860 200 L835 270 L850 275 L825 350 L845 360 L815 440 L835 450 L805 530 L825 540 L795 620 L815 630 L785 710 L805 720 L775 800 L795 810 L765 890 L785 900 L755 980"
          stroke="url(#blueThunder)"
          stroke-width="3.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.65"
        />
        <path
          d="M835 270 L870 310 L860 350"
          stroke="url(#blueThunder)"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.55"
        />
      </g>

      <g class="thunder-bolt-behind-2">
        <path
          d="M1100 120 L1095 170 L1105 175 L1090 230 L1110 240 L1085 310 L1100 315 L1075 390 L1095 400 L1065 480 L1085 490 L1055 570 L1075 580 L1045 660 L1065 670 L1035 750 L1055 760 L1025 840 L1045 850 L1015 930"
          stroke="url(#blueThunder)"
          stroke-width="3.5"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.65"
        />
        <path
          d="M1085 310 L1050 350 L1060 390"
          stroke="url(#blueThunder)"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="miter"
          opacity="0.55"
        />
      </g>

      <!-- Energy particles (removed current-wave that causes blue line) -->
      <g class="energy-particle-1">
        <circle
          cx="600"
          cy="400"
          r="5"
          fill="#93c5fd"
          opacity="0.8"
          filter="url(#glow)"
        />
      </g>
      <g class="energy-particle-2">
        <circle
          cx="1300"
          cy="500"
          r="5"
          fill="#93c5fd"
          opacity="0.8"
          filter="url(#glow)"
        />
      </g>
      <g class="energy-particle-3">
        <circle
          cx="800"
          cy="650"
          r="5"
          fill="#60a5fa"
          opacity="0.8"
          filter="url(#glow)"
        />
      </g>
    </svg>
  </div>

  <!-- Login Form -->
  <div class="form-container active" id="loginForm">
    <div class="brand-header">
      <div class="brand-logo">
        <span>⚡</span>
        <span>Ride Electric</span>
      </div>
      <div class="brand-tagline">
        Power up your journey with sustainable mobility
      </div>
    </div>

    <div class="success-banner" id="loginSuccess"></div>

    <form id="loginFormElement">
      <div class="input-group">
        <label class="input-label" for="loginEmail">Email Address</label>
        <input
            #loginEmail
            id="loginEmail"
            type="email"
            placeholder="your@email.com"
            [(ngModel)]="loginModel.username"
            (input)="onLoginUsernameInput(loginEmail.value)"
            name="loginEmail"
            class="input-field"
            required
          />
        <div class="error-text" id="loginEmailError">
          Please enter a valid email
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="loginPassword">Password</label>
        <input
            id="loginPassword"
            type="password"
            placeholder="Enter your password"
            [(ngModel)]="loginModel.password"
            name="loginPassword"
            class="input-field"
            required
          />
        <div class="error-text" id="loginPasswordError">
          Password is required
        </div>
      </div>

      <button type="submit" class="primary-button">Start Riding</button>

      <!-- Error/Success Messages -->
      <div id="loginSuccess" class="success-message"></div>
      <div *ngIf="loginError" class="error-banner">{{ loginError }}</div>

    </form>

    <div style="text-align: center; margin-top: 16px">
      <button class="switch-link" id="forgotPassword" style="font-size: 14px">
        Forgot password?
      </button>
    </div>

    <div class="divider-line">
      <span>or</span>
    </div>

    <div class="switch-mode">
      New to e-bikes?
      <button class="switch-link" id="switchToRegister">
        Join the revolution
      </button>
    </div>
  </div>

  <!-- Register Form -->
  <div class="form-container slide-in-left" id="registerForm">
    <div class="brand-header">
      <div class="brand-logo">
        <span>🚴</span>
        <span>Join the Ride</span>
      </div>
      <div class="brand-tagline">Start your electric journey today</div>
    </div>

    <div class="success-banner" id="registerSuccess"></div>

    <form id="registerFormElement">
      <div class="input-group">
        <label class="input-label" for="registerName">Username</label>
        <input
          type="text"
          class="input-field"
          id="registerName"
          placeholder="John Doe"
          required
        />
        <div class="error-text" id="registerNameError">Name is required</div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerEmail">Email Address</label>
        <input
          type="email"
          class="input-field"
          id="registerEmail"
          placeholder="your@email.com"
          required
        />
        <div class="error-text" id="registerEmailError">
          Please enter a valid email
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerPassword">Password</label>
        <div class="input-with-eye">
          <input
            type="password"
            class="input-field"
            id="registerPassword"
            placeholder="Min. 8 characters"
            required
          />
          <button type="button" class="show-hide-btn" id="togglePassword">
            <img src="login/password-eye-royalty.png" alt="Show or hide password"/>
          </button>
        </div>
        <div class="error-text" id="registerPasswordError">
          Password must be at least 8 characters, include uppercase, number, and
          symbol.
        </div>
      </div>

      <!-- Password strength meter and rules, hidden initially -->
      <div
        class="password-strength-container hide"
        id="passwordStrengthContainer"
      >
        <div class="password-strength-bar">
          <div id="passwordStrengthFill"></div>
        </div>
        <ul class="password-rules-list" id="passwordRulesList">
          <li id="pwLength" class="pw-rule">Minimum 8 characters</li>
          <li id="pwUpper" class="pw-rule">At least one uppercase letter</li>
          <li id="pwNumber" class="pw-rule">At least one number</li>
          <li id="pwSymbol" class="pw-rule">At least one symbol</li>
        </ul>
      </div>

      <!-- Confirm password input with show/hide button -->
      <div class="input-group">
        <label class="input-label" for="registerConfirmPassword"
          >Confirm Password</label
        >
        <div class="input-with-eye">
          <input
            type="password"
            class="input-field"
            id="registerConfirmPassword"
            placeholder="Re-enter password"
            required
          />
          <button
            type="button"
            class="show-hide-btn"
            id="toggleConfirmPassword"
          >
            <img src="login/password-eye-royalty.png" alt="Show or hide password"/>
          </button>
        </div>
        <div class="error-text" id="registerConfirmPasswordError">
          Passwords do not match
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerDeviceId">Device ID</label>
        <input
          type="text"
          class="input-field"
          id="registerDeviceId"
          placeholder="Enter your Device ID"
          required
        />
        <div class="error-text" id="registerDeviceIdError">
          Device ID is required
        </div>
      </div>

      <button type="submit" class="primary-button">Create Account</button>
    </form>

    <div class="divider-line">
      <span>or</span>
    </div>

    <div class="switch-mode">
      Already riding with us?
      <button class="switch-link" id="switchToLogin">Sign in</button>
    </div>
  </div>
</div>
